import React, { useEffect, useRef, useState } from 'react';

interface ScrollableContentProps {
  children: React.ReactNode;
  className?: string;
  showScrollIndicators?: boolean;
}

const ScrollableContent: React.FC<ScrollableContentProps> = ({ 
  children, 
  className = '',
  showScrollIndicators = true
}) => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [isScrolledTop, setIsScrolledTop] = useState(false);
  const [isScrolledBottom, setIsScrolledBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (!scrollRef.current) return;

      const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
      
      // Check if scrolled from top
      setIsScrolledTop(scrollTop > 10);
      
      // Check if scrolled from bottom
      setIsScrolledBottom(scrollTop < scrollHeight - clientHeight - 10);
    };

    const scrollElement = scrollRef.current;
    if (scrollElement) {
      scrollElement.addEventListener('scroll', handleScroll);
      // Initial check
      handleScroll();
      
      return () => {
        scrollElement.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);

  return (
    <div 
      ref={scrollRef}
      className={`
        scrollable-content
        flex-1 overflow-y-auto overflow-x-hidden
        px-6 py-4
        ${showScrollIndicators ? 'scroll-indicators' : ''}
        ${isScrolledTop ? 'scrolled-top' : ''}
        ${isScrolledBottom ? 'scrolled-bottom' : ''}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

export default ScrollableContent; 